// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  ClaimEntitlementRequest,
  ClaimEntitlementResponse,
  CreateEntitlementRequest,
  CreateEntitlementResponse,
  CreateOverrideRequest,
  CreateOverrideResponse,
  DeleteOverrideRequest,
  EntitlementStatus,
  EntitlementType,
  FindMarketplaceResponse,
  GetEntitlementResponse,
  GetEntitlementsResponse,
  GetMarketplaceResponse,
  GetOverridesResponse,
  GetPaymentProcessorResponse,
  GetResponse,
  GetTransitionResponse,
  LinkProjectRequest,
  LinkProjectResponse,
  SetMarketplaceActivationStateRequest,
  SetProductCatalogueVersionRequest,
  UpdateEntitlementRequest,
} from '../models/index';
import {
  ClaimEntitlementRequestFromJSON,
  ClaimEntitlementRequestToJSON,
  ClaimEntitlementResponseFromJSON,
  ClaimEntitlementResponseToJSON,
  CreateEntitlementRequestFromJSON,
  CreateEntitlementRequestToJSON,
  CreateEntitlementResponseFromJSON,
  CreateEntitlementResponseToJSON,
  CreateOverrideRequestFromJSON,
  CreateOverrideRequestToJSON,
  CreateOverrideResponseFromJSON,
  CreateOverrideResponseToJSON,
  DeleteOverrideRequestFromJSON,
  DeleteOverrideRequestToJSON,
  EntitlementStatusFromJSON,
  EntitlementStatusToJSON,
  EntitlementTypeFromJSON,
  EntitlementTypeToJSON,
  FindMarketplaceResponseFromJSON,
  FindMarketplaceResponseToJSON,
  GetEntitlementResponseFromJSON,
  GetEntitlementResponseToJSON,
  GetEntitlementsResponseFromJSON,
  GetEntitlementsResponseToJSON,
  GetMarketplaceResponseFromJSON,
  GetMarketplaceResponseToJSON,
  GetOverridesResponseFromJSON,
  GetOverridesResponseToJSON,
  GetPaymentProcessorResponseFromJSON,
  GetPaymentProcessorResponseToJSON,
  GetResponseFromJSON,
  GetResponseToJSON,
  GetTransitionResponseFromJSON,
  GetTransitionResponseToJSON,
  LinkProjectRequestFromJSON,
  LinkProjectRequestToJSON,
  LinkProjectResponseFromJSON,
  LinkProjectResponseToJSON,
  SetMarketplaceActivationStateRequestFromJSON,
  SetMarketplaceActivationStateRequestToJSON,
  SetProductCatalogueVersionRequestFromJSON,
  SetProductCatalogueVersionRequestToJSON,
  UpdateEntitlementRequestFromJSON,
  UpdateEntitlementRequestToJSON,
} from '../models/index';

export interface V1AuraPortalAccountsBillingIDActivatePutRequest {
  billingID: string;
}

export interface V1AuraPortalAccountsBillingIDLinkPostRequest {
  billingID: string;
  linkProjectRequest: LinkProjectRequest;
}

export interface V1AuraPortalAccountsBillingIDMarketplaceGetRequest {
  billingID: string;
}

export interface V1AuraPortalAccountsBillingIDOverridesGetRequest {
  billingID: string;
}

export interface V1AuraPortalAccountsBillingIDOverridesOverrideIDDeleteRequest {
  billingID: string;
  overrideID: string;
  deleteOverrideRequest: DeleteOverrideRequest;
}

export interface V1AuraPortalAccountsBillingIDOverridesPostRequest {
  billingID: string;
  createOverrideRequest: CreateOverrideRequest;
}

export interface V1AuraPortalAccountsBillingIDPaymentProcessorGetRequest {
  billingID: string;
}

export interface V1AuraPortalAccountsBillingIDProductCatalogueVersionPutRequest {
  billingID: string;
  setProductCatalogueVersionRequest: SetProductCatalogueVersionRequest;
}

export interface V1AuraPortalAccountsBillingIDTransitionsGetRequest {
  billingID: string;
}

export interface V1AuraPortalAccountsGetRequest {
  billingID?: string;
  projectID?: string;
  organizationID?: string;
  entitlementID?: string;
}

export interface V1AuraPortalAccountsMarketplaceMarketplaceIDActivationStatePutRequest {
  marketplaceID: string;
  setMarketplaceActivationStateRequest: SetMarketplaceActivationStateRequest;
}

export interface V1AuraPortalEntitlementsEntitlementIDClaimPutRequest {
  entitlementID: string;
  claimEntitlementRequest: ClaimEntitlementRequest;
}

export interface V1AuraPortalEntitlementsEntitlementIDDeleteRequest {
  entitlementID: string;
}

export interface V1AuraPortalEntitlementsEntitlementIDGetRequest {
  entitlementID: string;
}

export interface V1AuraPortalEntitlementsEntitlementIDPutRequest {
  entitlementID: string;
  updateEntitlementRequest: UpdateEntitlementRequest;
}

export interface V1AuraPortalEntitlementsEntitlementIDVoidPutRequest {
  entitlementID: string;
}

export interface V1AuraPortalEntitlementsGetRequest {
  billingAccountID: string;
  type?: EntitlementType;
  status?: EntitlementStatus;
}

export interface V1AuraPortalEntitlementsPostRequest {
  createEntitlementRequest: CreateEntitlementRequest;
}

export interface V1AuraPortalMarketplaceGetRequest {
  id?: string;
  externalAccountID?: string;
  externalReportingID?: string;
  entitlementID?: string;
}

/**
 *
 */
export class AuraPortalApi extends runtime.BaseAPI {
  /**
   * Publishes an activation message and returns the account.
   * Publish activation event for a billing account
   */
  async v1AuraPortalAccountsBillingIDActivatePutRaw(
    requestParameters: V1AuraPortalAccountsBillingIDActivatePutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetResponse>> {
    if (requestParameters['billingID'] == null) {
      throw new runtime.RequiredError(
        'billingID',
        'Required parameter "billingID" was null or undefined when calling v1AuraPortalAccountsBillingIDActivatePut().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/aura-portal/accounts/{billingID}/activate`;
    urlPath = urlPath.replace(
      `{${'billingID'}}`,
      encodeURIComponent(String(requestParameters['billingID'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      GetResponseFromJSON(jsonValue),
    );
  }

  /**
   * Publishes an activation message and returns the account.
   * Publish activation event for a billing account
   */
  async v1AuraPortalAccountsBillingIDActivatePut(
    requestParameters: V1AuraPortalAccountsBillingIDActivatePutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetResponse> {
    const response = await this.v1AuraPortalAccountsBillingIDActivatePutRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Links a project to the billing account, optionally forcing relink.
   * Link a project to a billing account
   */
  async v1AuraPortalAccountsBillingIDLinkPostRaw(
    requestParameters: V1AuraPortalAccountsBillingIDLinkPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LinkProjectResponse>> {
    if (requestParameters['billingID'] == null) {
      throw new runtime.RequiredError(
        'billingID',
        'Required parameter "billingID" was null or undefined when calling v1AuraPortalAccountsBillingIDLinkPost().',
      );
    }

    if (requestParameters['linkProjectRequest'] == null) {
      throw new runtime.RequiredError(
        'linkProjectRequest',
        'Required parameter "linkProjectRequest" was null or undefined when calling v1AuraPortalAccountsBillingIDLinkPost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/v1/aura-portal/accounts/{billingID}/link`;
    urlPath = urlPath.replace(
      `{${'billingID'}}`,
      encodeURIComponent(String(requestParameters['billingID'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: LinkProjectRequestToJSON(requestParameters['linkProjectRequest']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      LinkProjectResponseFromJSON(jsonValue),
    );
  }

  /**
   * Links a project to the billing account, optionally forcing relink.
   * Link a project to a billing account
   */
  async v1AuraPortalAccountsBillingIDLinkPost(
    requestParameters: V1AuraPortalAccountsBillingIDLinkPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LinkProjectResponse> {
    const response = await this.v1AuraPortalAccountsBillingIDLinkPostRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Returns the marketplace linked to the billing account, if any.
   * Get marketplace link for a billing account
   */
  async v1AuraPortalAccountsBillingIDMarketplaceGetRaw(
    requestParameters: V1AuraPortalAccountsBillingIDMarketplaceGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetMarketplaceResponse>> {
    if (requestParameters['billingID'] == null) {
      throw new runtime.RequiredError(
        'billingID',
        'Required parameter "billingID" was null or undefined when calling v1AuraPortalAccountsBillingIDMarketplaceGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/aura-portal/accounts/{billingID}/marketplace`;
    urlPath = urlPath.replace(
      `{${'billingID'}}`,
      encodeURIComponent(String(requestParameters['billingID'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      GetMarketplaceResponseFromJSON(jsonValue),
    );
  }

  /**
   * Returns the marketplace linked to the billing account, if any.
   * Get marketplace link for a billing account
   */
  async v1AuraPortalAccountsBillingIDMarketplaceGet(
    requestParameters: V1AuraPortalAccountsBillingIDMarketplaceGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetMarketplaceResponse> {
    const response = await this.v1AuraPortalAccountsBillingIDMarketplaceGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Returns all funding overrides for a billing account.
   * Get funding overrides for a billing account
   */
  async v1AuraPortalAccountsBillingIDOverridesGetRaw(
    requestParameters: V1AuraPortalAccountsBillingIDOverridesGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetOverridesResponse>> {
    if (requestParameters['billingID'] == null) {
      throw new runtime.RequiredError(
        'billingID',
        'Required parameter "billingID" was null or undefined when calling v1AuraPortalAccountsBillingIDOverridesGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/aura-portal/accounts/{billingID}/overrides`;
    urlPath = urlPath.replace(
      `{${'billingID'}}`,
      encodeURIComponent(String(requestParameters['billingID'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      GetOverridesResponseFromJSON(jsonValue),
    );
  }

  /**
   * Returns all funding overrides for a billing account.
   * Get funding overrides for a billing account
   */
  async v1AuraPortalAccountsBillingIDOverridesGet(
    requestParameters: V1AuraPortalAccountsBillingIDOverridesGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetOverridesResponse> {
    const response = await this.v1AuraPortalAccountsBillingIDOverridesGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Soft-deletes a funding override and publishes a lifecycle event.
   * Delete a funding override
   */
  async v1AuraPortalAccountsBillingIDOverridesOverrideIDDeleteRaw(
    requestParameters: V1AuraPortalAccountsBillingIDOverridesOverrideIDDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['billingID'] == null) {
      throw new runtime.RequiredError(
        'billingID',
        'Required parameter "billingID" was null or undefined when calling v1AuraPortalAccountsBillingIDOverridesOverrideIDDelete().',
      );
    }

    if (requestParameters['overrideID'] == null) {
      throw new runtime.RequiredError(
        'overrideID',
        'Required parameter "overrideID" was null or undefined when calling v1AuraPortalAccountsBillingIDOverridesOverrideIDDelete().',
      );
    }

    if (requestParameters['deleteOverrideRequest'] == null) {
      throw new runtime.RequiredError(
        'deleteOverrideRequest',
        'Required parameter "deleteOverrideRequest" was null or undefined when calling v1AuraPortalAccountsBillingIDOverridesOverrideIDDelete().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/v1/aura-portal/accounts/{billingID}/overrides/{overrideID}`;
    urlPath = urlPath.replace(
      `{${'billingID'}}`,
      encodeURIComponent(String(requestParameters['billingID'])),
    );
    urlPath = urlPath.replace(
      `{${'overrideID'}}`,
      encodeURIComponent(String(requestParameters['overrideID'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
        body: DeleteOverrideRequestToJSON(
          requestParameters['deleteOverrideRequest'],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Soft-deletes a funding override and publishes a lifecycle event.
   * Delete a funding override
   */
  async v1AuraPortalAccountsBillingIDOverridesOverrideIDDelete(
    requestParameters: V1AuraPortalAccountsBillingIDOverridesOverrideIDDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.v1AuraPortalAccountsBillingIDOverridesOverrideIDDeleteRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   * Creates a new funding override for a billing account.
   * Create a funding override for a billing account
   */
  async v1AuraPortalAccountsBillingIDOverridesPostRaw(
    requestParameters: V1AuraPortalAccountsBillingIDOverridesPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CreateOverrideResponse>> {
    if (requestParameters['billingID'] == null) {
      throw new runtime.RequiredError(
        'billingID',
        'Required parameter "billingID" was null or undefined when calling v1AuraPortalAccountsBillingIDOverridesPost().',
      );
    }

    if (requestParameters['createOverrideRequest'] == null) {
      throw new runtime.RequiredError(
        'createOverrideRequest',
        'Required parameter "createOverrideRequest" was null or undefined when calling v1AuraPortalAccountsBillingIDOverridesPost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/v1/aura-portal/accounts/{billingID}/overrides`;
    urlPath = urlPath.replace(
      `{${'billingID'}}`,
      encodeURIComponent(String(requestParameters['billingID'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CreateOverrideRequestToJSON(
          requestParameters['createOverrideRequest'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      CreateOverrideResponseFromJSON(jsonValue),
    );
  }

  /**
   * Creates a new funding override for a billing account.
   * Create a funding override for a billing account
   */
  async v1AuraPortalAccountsBillingIDOverridesPost(
    requestParameters: V1AuraPortalAccountsBillingIDOverridesPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CreateOverrideResponse> {
    const response = await this.v1AuraPortalAccountsBillingIDOverridesPostRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Returns the payment processor linked to a billing account.
   * Get payment processor for a billing account
   */
  async v1AuraPortalAccountsBillingIDPaymentProcessorGetRaw(
    requestParameters: V1AuraPortalAccountsBillingIDPaymentProcessorGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetPaymentProcessorResponse>> {
    if (requestParameters['billingID'] == null) {
      throw new runtime.RequiredError(
        'billingID',
        'Required parameter "billingID" was null or undefined when calling v1AuraPortalAccountsBillingIDPaymentProcessorGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/aura-portal/accounts/{billingID}/payment-processor`;
    urlPath = urlPath.replace(
      `{${'billingID'}}`,
      encodeURIComponent(String(requestParameters['billingID'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      GetPaymentProcessorResponseFromJSON(jsonValue),
    );
  }

  /**
   * Returns the payment processor linked to a billing account.
   * Get payment processor for a billing account
   */
  async v1AuraPortalAccountsBillingIDPaymentProcessorGet(
    requestParameters: V1AuraPortalAccountsBillingIDPaymentProcessorGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetPaymentProcessorResponse> {
    const response =
      await this.v1AuraPortalAccountsBillingIDPaymentProcessorGetRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }

  /**
   * Moves a billing account onto a different product catalogue version. The requested version must be published by the product catalogue, or be \"latest\". A reason is mandatory and the change is logged with the caller\'s identity.
   * Set the product catalogue version for a billing account
   */
  async v1AuraPortalAccountsBillingIDProductCatalogueVersionPutRaw(
    requestParameters: V1AuraPortalAccountsBillingIDProductCatalogueVersionPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['billingID'] == null) {
      throw new runtime.RequiredError(
        'billingID',
        'Required parameter "billingID" was null or undefined when calling v1AuraPortalAccountsBillingIDProductCatalogueVersionPut().',
      );
    }

    if (requestParameters['setProductCatalogueVersionRequest'] == null) {
      throw new runtime.RequiredError(
        'setProductCatalogueVersionRequest',
        'Required parameter "setProductCatalogueVersionRequest" was null or undefined when calling v1AuraPortalAccountsBillingIDProductCatalogueVersionPut().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/v1/aura-portal/accounts/{billingID}/product-catalogue-version`;
    urlPath = urlPath.replace(
      `{${'billingID'}}`,
      encodeURIComponent(String(requestParameters['billingID'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: SetProductCatalogueVersionRequestToJSON(
          requestParameters['setProductCatalogueVersionRequest'],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Moves a billing account onto a different product catalogue version. The requested version must be published by the product catalogue, or be \"latest\". A reason is mandatory and the change is logged with the caller\'s identity.
   * Set the product catalogue version for a billing account
   */
  async v1AuraPortalAccountsBillingIDProductCatalogueVersionPut(
    requestParameters: V1AuraPortalAccountsBillingIDProductCatalogueVersionPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.v1AuraPortalAccountsBillingIDProductCatalogueVersionPutRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   * Returns the funding state transitions for a billing account, ordered by timestamp.
   * List funding transitions for a billing account
   */
  async v1AuraPortalAccountsBillingIDTransitionsGetRaw(
    requestParameters: V1AuraPortalAccountsBillingIDTransitionsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetTransitionResponse>> {
    if (requestParameters['billingID'] == null) {
      throw new runtime.RequiredError(
        'billingID',
        'Required parameter "billingID" was null or undefined when calling v1AuraPortalAccountsBillingIDTransitionsGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/aura-portal/accounts/{billingID}/transitions`;
    urlPath = urlPath.replace(
      `{${'billingID'}}`,
      encodeURIComponent(String(requestParameters['billingID'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      GetTransitionResponseFromJSON(jsonValue),
    );
  }

  /**
   * Returns the funding state transitions for a billing account, ordered by timestamp.
   * List funding transitions for a billing account
   */
  async v1AuraPortalAccountsBillingIDTransitionsGet(
    requestParameters: V1AuraPortalAccountsBillingIDTransitionsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetTransitionResponse> {
    const response = await this.v1AuraPortalAccountsBillingIDTransitionsGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Returns billing accounts filtered by exactly one of billingID, projectID, organizationID, or entitlementID.
   * List billing accounts
   */
  async v1AuraPortalAccountsGetRaw(
    requestParameters: V1AuraPortalAccountsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<GetResponse>>> {
    const queryParameters: any = {};

    if (requestParameters['billingID'] != null) {
      queryParameters['billingID'] = requestParameters['billingID'];
    }

    if (requestParameters['projectID'] != null) {
      queryParameters['projectID'] = requestParameters['projectID'];
    }

    if (requestParameters['organizationID'] != null) {
      queryParameters['organizationID'] = requestParameters['organizationID'];
    }

    if (requestParameters['entitlementID'] != null) {
      queryParameters['entitlementID'] = requestParameters['entitlementID'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/aura-portal/accounts`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(GetResponseFromJSON),
    );
  }

  /**
   * Returns billing accounts filtered by exactly one of billingID, projectID, organizationID, or entitlementID.
   * List billing accounts
   */
  async v1AuraPortalAccountsGet(
    requestParameters: V1AuraPortalAccountsGetRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<GetResponse>> {
    const response = await this.v1AuraPortalAccountsGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Updates the activation state (isActive and inactiveReason) of a marketplace. Requires funding admin role.
   * Set marketplace activation state
   */
  async v1AuraPortalAccountsMarketplaceMarketplaceIDActivationStatePutRaw(
    requestParameters: V1AuraPortalAccountsMarketplaceMarketplaceIDActivationStatePutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['marketplaceID'] == null) {
      throw new runtime.RequiredError(
        'marketplaceID',
        'Required parameter "marketplaceID" was null or undefined when calling v1AuraPortalAccountsMarketplaceMarketplaceIDActivationStatePut().',
      );
    }

    if (requestParameters['setMarketplaceActivationStateRequest'] == null) {
      throw new runtime.RequiredError(
        'setMarketplaceActivationStateRequest',
        'Required parameter "setMarketplaceActivationStateRequest" was null or undefined when calling v1AuraPortalAccountsMarketplaceMarketplaceIDActivationStatePut().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/v1/aura-portal/accounts/marketplace/{marketplaceID}/activation-state`;
    urlPath = urlPath.replace(
      `{${'marketplaceID'}}`,
      encodeURIComponent(String(requestParameters['marketplaceID'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: SetMarketplaceActivationStateRequestToJSON(
          requestParameters['setMarketplaceActivationStateRequest'],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Updates the activation state (isActive and inactiveReason) of a marketplace. Requires funding admin role.
   * Set marketplace activation state
   */
  async v1AuraPortalAccountsMarketplaceMarketplaceIDActivationStatePut(
    requestParameters: V1AuraPortalAccountsMarketplaceMarketplaceIDActivationStatePutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.v1AuraPortalAccountsMarketplaceMarketplaceIDActivationStatePutRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   * Claim entitlement
   * Claim entitlement
   */
  async v1AuraPortalEntitlementsEntitlementIDClaimPutRaw(
    requestParameters: V1AuraPortalEntitlementsEntitlementIDClaimPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ClaimEntitlementResponse>> {
    if (requestParameters['entitlementID'] == null) {
      throw new runtime.RequiredError(
        'entitlementID',
        'Required parameter "entitlementID" was null or undefined when calling v1AuraPortalEntitlementsEntitlementIDClaimPut().',
      );
    }

    if (requestParameters['claimEntitlementRequest'] == null) {
      throw new runtime.RequiredError(
        'claimEntitlementRequest',
        'Required parameter "claimEntitlementRequest" was null or undefined when calling v1AuraPortalEntitlementsEntitlementIDClaimPut().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/v1/aura-portal/entitlements/{entitlementID}/claim`;
    urlPath = urlPath.replace(
      `{${'entitlementID'}}`,
      encodeURIComponent(String(requestParameters['entitlementID'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: ClaimEntitlementRequestToJSON(
          requestParameters['claimEntitlementRequest'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ClaimEntitlementResponseFromJSON(jsonValue),
    );
  }

  /**
   * Claim entitlement
   * Claim entitlement
   */
  async v1AuraPortalEntitlementsEntitlementIDClaimPut(
    requestParameters: V1AuraPortalEntitlementsEntitlementIDClaimPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ClaimEntitlementResponse> {
    const response =
      await this.v1AuraPortalEntitlementsEntitlementIDClaimPutRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }

  /**
   * Deletes an entitlement and publishes a message to remove associated credit blocks. Only supported for prepaid accounts and within 62 days of the entitlement start date.
   * Delete entitlement
   */
  async v1AuraPortalEntitlementsEntitlementIDDeleteRaw(
    requestParameters: V1AuraPortalEntitlementsEntitlementIDDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['entitlementID'] == null) {
      throw new runtime.RequiredError(
        'entitlementID',
        'Required parameter "entitlementID" was null or undefined when calling v1AuraPortalEntitlementsEntitlementIDDelete().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/aura-portal/entitlements/{entitlementID}`;
    urlPath = urlPath.replace(
      `{${'entitlementID'}}`,
      encodeURIComponent(String(requestParameters['entitlementID'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Deletes an entitlement and publishes a message to remove associated credit blocks. Only supported for prepaid accounts and within 62 days of the entitlement start date.
   * Delete entitlement
   */
  async v1AuraPortalEntitlementsEntitlementIDDelete(
    requestParameters: V1AuraPortalEntitlementsEntitlementIDDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.v1AuraPortalEntitlementsEntitlementIDDeleteRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   * Get entitlement details
   * Get entitlement details
   */
  async v1AuraPortalEntitlementsEntitlementIDGetRaw(
    requestParameters: V1AuraPortalEntitlementsEntitlementIDGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetEntitlementResponse>> {
    if (requestParameters['entitlementID'] == null) {
      throw new runtime.RequiredError(
        'entitlementID',
        'Required parameter "entitlementID" was null or undefined when calling v1AuraPortalEntitlementsEntitlementIDGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/aura-portal/entitlements/{entitlementID}`;
    urlPath = urlPath.replace(
      `{${'entitlementID'}}`,
      encodeURIComponent(String(requestParameters['entitlementID'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      GetEntitlementResponseFromJSON(jsonValue),
    );
  }

  /**
   * Get entitlement details
   * Get entitlement details
   */
  async v1AuraPortalEntitlementsEntitlementIDGet(
    requestParameters: V1AuraPortalEntitlementsEntitlementIDGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetEntitlementResponse> {
    const response = await this.v1AuraPortalEntitlementsEntitlementIDGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Updates the mutable fields of an entitlement. Only supported for entitlements that have not been claimed yet.
   * Update entitlement
   */
  async v1AuraPortalEntitlementsEntitlementIDPutRaw(
    requestParameters: V1AuraPortalEntitlementsEntitlementIDPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetEntitlementResponse>> {
    if (requestParameters['entitlementID'] == null) {
      throw new runtime.RequiredError(
        'entitlementID',
        'Required parameter "entitlementID" was null or undefined when calling v1AuraPortalEntitlementsEntitlementIDPut().',
      );
    }

    if (requestParameters['updateEntitlementRequest'] == null) {
      throw new runtime.RequiredError(
        'updateEntitlementRequest',
        'Required parameter "updateEntitlementRequest" was null or undefined when calling v1AuraPortalEntitlementsEntitlementIDPut().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/v1/aura-portal/entitlements/{entitlementID}`;
    urlPath = urlPath.replace(
      `{${'entitlementID'}}`,
      encodeURIComponent(String(requestParameters['entitlementID'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: UpdateEntitlementRequestToJSON(
          requestParameters['updateEntitlementRequest'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      GetEntitlementResponseFromJSON(jsonValue),
    );
  }

  /**
   * Updates the mutable fields of an entitlement. Only supported for entitlements that have not been claimed yet.
   * Update entitlement
   */
  async v1AuraPortalEntitlementsEntitlementIDPut(
    requestParameters: V1AuraPortalEntitlementsEntitlementIDPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetEntitlementResponse> {
    const response = await this.v1AuraPortalEntitlementsEntitlementIDPutRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Voids an entitlement by setting its status to void. This action is irreversible and prevents the entitlement from being used for billing purposes.
   * Void entitlement
   */
  async v1AuraPortalEntitlementsEntitlementIDVoidPutRaw(
    requestParameters: V1AuraPortalEntitlementsEntitlementIDVoidPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['entitlementID'] == null) {
      throw new runtime.RequiredError(
        'entitlementID',
        'Required parameter "entitlementID" was null or undefined when calling v1AuraPortalEntitlementsEntitlementIDVoidPut().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/aura-portal/entitlements/{entitlementID}/void`;
    urlPath = urlPath.replace(
      `{${'entitlementID'}}`,
      encodeURIComponent(String(requestParameters['entitlementID'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Voids an entitlement by setting its status to void. This action is irreversible and prevents the entitlement from being used for billing purposes.
   * Void entitlement
   */
  async v1AuraPortalEntitlementsEntitlementIDVoidPut(
    requestParameters: V1AuraPortalEntitlementsEntitlementIDVoidPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.v1AuraPortalEntitlementsEntitlementIDVoidPutRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   * Lists entitlements based on the provided query parameters
   * Lists entitlements based on the provided query parameters
   */
  async v1AuraPortalEntitlementsGetRaw(
    requestParameters: V1AuraPortalEntitlementsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetEntitlementsResponse>> {
    if (requestParameters['billingAccountID'] == null) {
      throw new runtime.RequiredError(
        'billingAccountID',
        'Required parameter "billingAccountID" was null or undefined when calling v1AuraPortalEntitlementsGet().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['billingAccountID'] != null) {
      queryParameters['billingAccountID'] =
        requestParameters['billingAccountID'];
    }

    if (requestParameters['type'] != null) {
      queryParameters['type'] = requestParameters['type'];
    }

    if (requestParameters['status'] != null) {
      queryParameters['status'] = requestParameters['status'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/aura-portal/entitlements`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      GetEntitlementsResponseFromJSON(jsonValue),
    );
  }

  /**
   * Lists entitlements based on the provided query parameters
   * Lists entitlements based on the provided query parameters
   */
  async v1AuraPortalEntitlementsGet(
    requestParameters: V1AuraPortalEntitlementsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetEntitlementsResponse> {
    const response = await this.v1AuraPortalEntitlementsGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Creates a new entitlement
   * Creates a new entitlement
   */
  async v1AuraPortalEntitlementsPostRaw(
    requestParameters: V1AuraPortalEntitlementsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CreateEntitlementResponse>> {
    if (requestParameters['createEntitlementRequest'] == null) {
      throw new runtime.RequiredError(
        'createEntitlementRequest',
        'Required parameter "createEntitlementRequest" was null or undefined when calling v1AuraPortalEntitlementsPost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/v1/aura-portal/entitlements`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CreateEntitlementRequestToJSON(
          requestParameters['createEntitlementRequest'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      CreateEntitlementResponseFromJSON(jsonValue),
    );
  }

  /**
   * Creates a new entitlement
   * Creates a new entitlement
   */
  async v1AuraPortalEntitlementsPost(
    requestParameters: V1AuraPortalEntitlementsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CreateEntitlementResponse> {
    const response = await this.v1AuraPortalEntitlementsPostRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Finds a marketplace link by one of: id, externalAccountID, externalReportingID, or entitlementID. At least one of these query parameters must be provided.
   * Find marketplace
   */
  async v1AuraPortalMarketplaceGetRaw(
    requestParameters: V1AuraPortalMarketplaceGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<FindMarketplaceResponse>> {
    const queryParameters: any = {};

    if (requestParameters['id'] != null) {
      queryParameters['id'] = requestParameters['id'];
    }

    if (requestParameters['externalAccountID'] != null) {
      queryParameters['externalAccountID'] =
        requestParameters['externalAccountID'];
    }

    if (requestParameters['externalReportingID'] != null) {
      queryParameters['externalReportingID'] =
        requestParameters['externalReportingID'];
    }

    if (requestParameters['entitlementID'] != null) {
      queryParameters['entitlementID'] = requestParameters['entitlementID'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/aura-portal/marketplace`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      FindMarketplaceResponseFromJSON(jsonValue),
    );
  }

  /**
   * Finds a marketplace link by one of: id, externalAccountID, externalReportingID, or entitlementID. At least one of these query parameters must be provided.
   * Find marketplace
   */
  async v1AuraPortalMarketplaceGet(
    requestParameters: V1AuraPortalMarketplaceGetRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<FindMarketplaceResponse> {
    const response = await this.v1AuraPortalMarketplaceGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
